import axios from "axios";

const sendMagicLinkEmail = async (email: string) => {
  const response = await axios.post(
    `${process.env.REACT_APP_IDENTITY_URL}/magic-link?email=${email}`
  );
  return response.data;
};

export default sendMagicLinkEmail;
